<template>
	<div class="myOrderContainer">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
		</div>
		<div class="orderListBox">
			<div class="orderMenu">
				<div class="menuItem">订单类型</div>
				<div class="menuItem">申请信息</div>
				<div class="menuItem">下单时间</div>
				<div class="menuItem">订单操作</div>
			</div>
			<div class="orderList" v-if="integralData.length">
				<div class="orderItem" v-for="(item,index) in integralData" :key="index">
					<div class="indexNum">{{item.type == 1 ? '积分' : '会员'}}订单</div>
					<div class="checkImgGoodsInfoBox">
						<div class="infoContent">{{item.title}}</div>
						<div class="infoPrice">订单金额：¥{{item.order_price}}</div>
					</div>
					<div class="goodsPrice">
						{{item.create_time}}
					</div>
					<div class="operation">
						<div class="download3d" @click="curOrder = item;dialogApplyInvoiceViable = true"
							v-if="item.status == 3">申请发票</div>
						<div class="download3d" style="background: rgba(22, 115, 230, .3);" v-if="item.status == 2">开票中
						</div>
						<div class="download3d" @click="curOrder = item;dialogReportVisible = true"
							v-if="item.status == 1">查看详情</div>
					</div>
				</div>
			</div>
			<el-empty description="暂无数据" v-else></el-empty>
		</div>
		<PagePagination style="padding: .08rem 0 0;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
		<LookDetailsDialog :show="dialogReportVisible" :data="curOrder" @close="dialogReportVisible = false" />
		<ApplyInvoiceDialog :show="dialogApplyInvoiceViable" :orderData="curOrder"
			@close="dialogApplyInvoiceViable = false" @update="sucPop = true;integralOrderList()" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'提交成功'" @clickOk="sucPop = false"
			v-if="sucPop" />
	</div>
</template>

<script>
	import LookDetailsDialog from '../../src/components/LookDetailsDialog.vue'
	import ApplyInvoiceDialog from '../../src/components/ApplyInvoiceDialog.vue'
	export default {
		name: 'MyInvoice',
		components: {
			LookDetailsDialog,
			ApplyInvoiceDialog
		},
		data() {
			return {
				// 分类导航
				categories: [{
						key: '1',
						name: '待申请'
					},
					{
						key: '2',
						name: '已申请'
					}
				],
				total: 0,
				curOrder: {},
				sucPop: false,
				currentPage: 1,
				integralData: [],
				activeCategory: '1',
				dialogReportVisible: false,
				dialogApplyInvoiceViable: false,
			}
		},
		mounted() {
			this.integralOrderList()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
			},
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.integralOrderList()
			},
			naviToDetails(item) {
				this.$router.push({
					path: '/order-details',
					query: {
						type: 4,
						orderId: item.id
					}
				})
			},
			confirmOrder(item) {
				this.$confirm('当前订单确认收货吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/OrderIntegral/integral_order_sh', {
						order_id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.integralOrderList()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			delOrder(item) {
				this.$confirm('确认删除当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/OrderIntegral/order_integral_del', {
						order_id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.integralOrderList()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			integralOrderList() {
				this.$api.post('/UserD/invoice_list', {
					p: 1,
					status: this.activeCategory
				}).then(res => {
					if (res.code == 1) {
						this.total = res.data.count
						this.integralData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.myOrderContainer {
		display: flex;
		flex-direction: column;
		padding: 0 .4rem .24rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .32);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: rgba(255, 255, 255, .6);
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: rgba(255, 255, 255, 1);
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: rgba(255, 255, 255, 1);
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: rgba(22, 115, 230, 1);
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	@media (max-width: 480px) {
		.orderMenu {
			display: flex;
			align-items: center;

			.menuItem {
				height: .5rem;
				font-weight: 400;
				font-size: .14rem;
				color: rgba(255, 255, 255, .4);
				text-align: center;
				line-height: .5rem;
			}

			.menuItem:nth-child(1) {
				width: 1.2rem;
			}

			.menuItem:nth-child(2) {
				width: 5rem;
			}

			.menuItem:nth-child(3) {
				width: 3.4rem;
			}

			.menuItem:nth-child(4) {
				width: 1.6rem;
			}
		}

		.orderItem {
			display: flex;
			align-items: center;
			margin-bottom: .16rem;
			height: .68rem;

			.indexNum {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 1.2rem;
				font-weight: 700;
				font-size: .16rem;
				color: #FFFFFF;
			}

			.checkImgGoodsInfoBox {
				width: 5rem;
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: 400;
				font-size: .16rem;
				color: #FFFFFF;
				line-height: .24rem;
				
				.infoContent{
					
				}
			}

			.goodsPrice {
				width: 3.4rem;
				font-weight: 700;
				font-size: .14rem;
				color: #FFFFFF;
				text-align: center;
			}

			.operation {
				width: 1.6rem;
				display: flex;
				align-items: center;
				justify-content: center;

				.download3d {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 1.52rem;
					height: .72rem;
					background: #1673E6;
					border-radius: .36rem;
					font-weight: 400;
					font-size: .28rem;
					color: #FFFFFF;
					line-height: .4rem;
					cursor: pointer;
				}
			}
		}
	}

	@media (min-width: 481px) {
		.orderMenu {
			display: flex;
			align-items: center;

			.menuItem {
				height: .5rem;
				font-weight: 400;
				font-size: .14rem;
				color: rgba(255, 255, 255, .4);
				text-align: center;
				line-height: .5rem;
			}

			.menuItem:nth-child(1) {
				width: .95rem;
			}

			.menuItem:nth-child(2) {
				width: 4rem;
			}

			.menuItem:nth-child(3) {
				width: 2.4rem;
			}

			.menuItem:nth-child(4) {
				width: 1.4rem;
			}
		}

		.orderItem {
			display: flex;
			align-items: center;
			margin-bottom: .16rem;
			height: .68rem;

			.indexNum {
				display: flex;
				align-items: center;
				justify-content: center;
				width: .95rem;
				font-weight: 700;
				font-size: .16rem;
				color: #FFFFFF;
			}

			.checkImgGoodsInfoBox {
				width: 4rem;
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: 400;
				font-size: .16rem;
				color: #FFFFFF;
				line-height: .24rem;
				
				.infoContent{
					width: 1.66rem;
				}
			}

			.goodsPrice {
				width: 2.4rem;
				font-weight: 700;
				font-size: .14rem;
				color: #FFFFFF;
				text-align: center;
			}

			.operation {
				width: 1.4rem;
				display: flex;
				align-items: center;
				justify-content: center;

				.download3d {
					margin-right: .08rem;
					display: flex;
					align-items: center;
					justify-content: center;
					width: .76rem;
					height: .36rem;
					background: #1673E6;
					border-radius: .18rem;
					font-weight: 400;
					font-size: .14rem;
					color: #FFFFFF;
					line-height: .2rem;
					cursor: pointer;
				}
			}
		}
	}

	.orderListBox {
		display: flex;
		flex-direction: column;

		.orderList {
			margin-top: .1rem;
			display: flex;
			flex-direction: column;
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;


				.wuLiuContent {
					margin-bottom: .16rem;
					font-weight: 400;
					font-size: .14rem;
					line-height: .2rem;
					color: #252525;
				}

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .16rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>